import * as go from 'gojs';
import { Point } from '../../models/point.interface';
import { MOUSE_CAPTURING_TOOL_NAME } from './config';
import { MouseCapturingTool } from './mouse-capturing-tool';

const setupMouseCapturingTool = (diagram: go.Diagram) =>
  diagram.toolManager.mouseDownTools.insertAt(0, new MouseCapturingTool());

const runMouseCapturingTool = (
  diagram: go.Diagram,
  cursor: string,
  allowedClickClass: string,
  action: (point: Point) => void,
) => {
  const tool = diagram.toolManager.findTool(MOUSE_CAPTURING_TOOL_NAME) as MouseCapturingTool;
  tool.cursor = cursor;
  tool.allowedClickClass = allowedClickClass;
  if (tool) {
    tool.startManually(action);
  }
};

export const mouseCapturingToolAPI = {
  setup: setupMouseCapturingTool,
  run: runMouseCapturingTool,
};
